// src/utils/productHelpers.js
// Derive ordering directly from product.json, preserving the exact key order
// as it appears in the source file (including integer-like purity keys such as
// "580", "650", "840" which V8 would otherwise sort numerically).
import segmentData from "./segmentData";
import { orderedKeysOf } from "./orderedJson";

/**
 * Returns segment keys in the order they appear in product.json.
 */
export const getOrderedSegments = () => orderedKeysOf(segmentData);

/**
 * Returns purity (category) keys for a given segment in the order they appear
 * in product.json. All segments keep the natural insertion order from
 * product.json, including integer-like purity keys.
 */
export const getOrderedPurityKeys = (segment) => {
  const segData = segmentData[segment];
  if (!segData) return [];
  return orderedKeysOf(segData);
};
